import * as THREE from 'three';
import { filesState } from './files.svelte.js';
/**
 * Grows `array` so that `index` is a valid insertion point. The old
 * grow-then-assign code left holes when an index was skipped; filling them with
 * the default keeps `??` fallbacks at read sites from seeing `undefined`.
 */
function padTo(array, index, fill) {
    while (array.length < index) {
        array.push(fill);
    }
}
export function insertEntryState(host, index, defaults) {
    padTo(host.fileVisibility, index, false);
    padTo(host.pointSizes, index, defaults.pointSize);
    padTo(host.individualColorModes, index, defaults.colorMode);
    padTo(host.transformationMatrices, index, new THREE.Matrix4());
    padTo(filesState.visibility, index, false);
    padTo(filesState.pointSizes, index, defaults.pointSize);
    padTo(filesState.colorModes, index, defaults.colorMode);
    padTo(filesState.collapsed, index, false);
    host.fileVisibility.splice(index, 0, defaults.visible);
    host.pointSizes.splice(index, 0, defaults.pointSize);
    host.individualColorModes.splice(index, 0, defaults.colorMode);
    host.transformationMatrices.splice(index, 0, new THREE.Matrix4());
    filesState.visibility.splice(index, 0, defaults.visible);
    filesState.pointSizes.splice(index, 0, defaults.pointSize);
    filesState.colorModes.splice(index, 0, defaults.colorMode);
    filesState.collapsed.splice(index, 0, false);
}
/**
 * Claims the file-list slot for a camera profile. Shared by the three sources
 * that publish one - JSON camera profiles, X3A archives and E57 images - which
 * previously each carried their own copy of this bookkeeping.
 *
 * Returns the unified index; the label/coordinate toggles are keyed by camera
 * index, matching cameraGroups and cameraNames.
 *
 * `parentId` ties the profile to the file that produced it, so removing that
 * file takes its cameras with it.
 */
export function registerCameraEntry(host, parentId = null) {
    const { index } = host.fileEntries.add('camera', parentId);
    insertEntryState(host, index, { visible: true, pointSize: 1, colorMode: 'assigned' });
    const cameraIndex = host.fileEntries.kindIndexAt(index);
    host.cameraShowLabels.splice(cameraIndex, 0, false);
    host.cameraShowCoords.splice(cameraIndex, 0, false);
    return index;
}
export function removeEntryState(host, index) {
    host.fileVisibility.splice(index, 1);
    host.pointSizes.splice(index, 1);
    host.individualColorModes.splice(index, 1);
    host.transformationMatrices.splice(index, 1);
    filesState.visibility.splice(index, 1);
    filesState.pointSizes.splice(index, 1);
    filesState.colorModes.splice(index, 1);
    filesState.collapsed.splice(index, 1);
}
